export const SENTRY_RELEASE: string | undefined = '0d94496465d8631232382c7af580fee98448af93';
